import template from './acris-faq-keyword-card-filter.html.twig';

const { Component } = Shopware;

Component.extend('acris-faq-keyword-card-filter', 'sw-card-filter', {
    template
});
